export default __webpack_public_path__ + "static/media/on_4.7110c083.mp3";